import React from 'react';
import { Chip } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import AccurityIcon from '../../../icon/components/AccurityIcon';
var ChipComponent = function (_a) {
    var _b = _a.label, label = _b === void 0 ? 'Removed' : _b, _c = _a.fullName, fullName = _c === void 0 ? 'Removed Reference' : _c, iconName = _a.iconName, active = _a.active, readOnly = _a.readOnly, onClick = _a.onClick, onDelete = _a.onDelete, children = _a.children;
    var handleOnClick = onClick
        ?
            function (event) {
                event.stopPropagation();
                onClick();
            }
        : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { contentEditable: false },
            React.createElement(Tooltip, { title: fullName },
                React.createElement(Chip, { label: label, size: "small", clickable: readOnly && active && !!handleOnClick, onDelete: readOnly ? undefined : onDelete, onClick: readOnly ? handleOnClick : undefined, icon: active && iconName ? React.createElement(AccurityIcon, { iconName: iconName, sx: { padding: 0.2 } }) : undefined }))),
        children));
};
export default ChipComponent;
//# sourceMappingURL=ChipComponent.js.map